import React from "react";
import BackButton from "components/shared/table/BackButton";

// The one page header for every screen.
//
// Titles used to come in four sizes (text-lg / text-xl / text-2xl / no class)
// with three different wrappers, and the back button existed on two screens
// only. This fixes all of that in one place:
//
//   <PageHeader
//     title="Cheque Dispatch"
//     subtitle="View and create dispatch records."
//     back={{ to: "/ChequeSettings", label: "Back to Settings" }}
//     actions={<button className="cg-btn">…</button>}
//   />
//
// `subtitle` covers both the sentence subtitles ("View and create dispatch
// records.") and the breadcrumb lines ("ChequeGuard / Operations") the
// operations screens used to render as `text-xs text-gray-500`.
const PageHeader = ({
  title,
  subtitle,
  back,
  actions,
  children,
  className = "",
}) => {
  const backProps = back === true ? {} : back;

  return (
    <div
      className={`flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between ${className}`.trim()}
    >
      <div className="min-w-0">
        {back && (
          <div className="mb-2">
            <BackButton {...backProps} />
          </div>
        )}
        {title && (
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        )}
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
        {children}
      </div>

      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-3">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
